import { render, staticRenderFns } from "./PermissionAdd.vue?vue&type=template&id=079b9a2d&scoped=true"
import script from "./PermissionAdd.vue?vue&type=script&lang=js"
export * from "./PermissionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b9a2d",
  null
  
)

export default component.exports